export const enSupportDashboard = {
	title: "Support Dashboard",
	searchPlaceholder: "Search by company name...",
	columns: {
		companyName: "Company Name",
		lastActivity: "Last Activity",
		lastActive: "Last Active",
		activity: "Activity",
		openScraping: "Open Scraping",
		runningCampaigns: "Running Campaigns",
		errors24h: "Send Errors",
		openTickets: "Open Tickets",
		waitingOnUs: "{{n}} waiting on us",
		messagesToday: "Messages Today",
		subscriptionType: "Subscription Type",
		billingInterval: "Billing Interval",
		creditsPerCommitment: "Credits / Commitment",
		availableCredits: "Credits (available / total)",
		emailsToday: "Emails Today",
		liInvitesToday: "LI Invites Today",
		liMessagesToday: "LI Messages Today",
	},
	filters: {
		openScrapingRequests: "Open Scraping Requests",
		runningCampaigns: "Running Campaigns",
		hasSendErrors: "Has send errors",
		lowOnCredits: "Low on credits",
	},
	range: {
		label: "Time range",
		today: "Today",
		yesterday: "Since yesterday",
		last7Days: "Last 7 days",
		last30Days: "Last 30 days",
	},
	kpis: {
		sendErrors: "Send errors needing attention",
		sendErrorsHint: "Across {{companies}} companies",
		inmailUndelivered: "Undelivered InMails",
		inmailUndeliveredHint: "No deliverable InMail path",
		disconnected: "Disconnected LinkedIn accounts",
		disconnectedHint: "Cause of cascading step failures",
		sentOk: "Steps sent OK",
		sentOkHint: "{{rate}}% success rate",
	},
	deliveryErrors: {
		title: "⚠ Delivery Errors",
		summary:
			"{{total}} failed steps · {{needsAttention}} need attention · {{inmailUndelivered}} undelivered InMails",
		legendAttention: "Needs attention (account / app-side)",
		legendRecipient: "Recipient-side (expected)",
		inmailMismatch: "InMail mismatch",
		loginAndOpen: "Login & Open",
		markFixed: "Mark fixed",
		noName: "Unknown prospect",
		loading: "Loading failed steps…",
		empty: "No failed steps in the selected range",
		showJson: "Show JSON",
		hideJson: "Hide JSON",
		copyJson: "Copy",
		copied: "Copied",
	},
	noData: "No companies found",
	expanded: {
		openScrapingRequests: "Open Scraping Requests",
		noOpenScrapingRequests: "No open scraping requests",
		runningCampaigns: "Running Campaigns",
		noRunningCampaigns: "No running campaigns",
		activityStats: "Activity Stats",
		noActivityRecorded: "No product usage recorded yet.",
		noActivityInWindow: "No product usage in the last 30 days.",
		notFullyMeasured:
			"Feature usage for the last 30 days is not fully measured yet: at least one day in that window has no completed rollup.",
		noRollupYet: "Daily usage appears after the first completed rollup.",
		feature: "Feature",
		day: "On {{date}}",
		sevenDays: "7 days",
		thirtyDays: "30 days",
		loginAndOpen: "Login & Open",
		emails: "emails",
		invites: "invites",
		messages: "messages",
	},
	activity: {
		summaryDay: "{{n}} on {{date}}",
		summaryWeek: "{{n}} in 7 days",
		summaryMonth: "{{n}} in 30 days",
		freshness: "Activity through {{date}}, complete UTC days",
		freshnessNone: "No completed activity rollup yet",
		lastActivityTooltip:
			"Latest UTC day with a recorded product event for this company, through the last nightly rollup ({{date}}). Daily precision; staff excluded.",
		activityTooltip:
			"Recorded product events (one per captured action, all surfaces) in complete UTC days through {{date}}. Not a count of people.",
	},
	subscriptionType: {
		FREE: "Free",
		PAID: "Paid",
		PAID_TRIAL: "Paid trial",
		FREE_EXPIRED: "Free – Expired",
	},
	billingInterval: {
		MONTHLY: "Monthly",
		EVERY_3_MONTHS: "Every 3 months",
		EVERY_6_MONTHS: "Every 6 months",
		YEARLY: "Yearly",
	},
	tabs: {
		companies: "Companies",
		users: "Users",
	},
	users: {
		searchPlaceholder: "Search by first name, last name, or company...",
		noData: "No users found",
		filters: {
			linkedinDisconnected: "LinkedIn disconnected",
		},
		columns: {
			name: "Name",
			company: "Company",
			sendingUser: "Sending User",
			linkedinConnected: "LinkedIn",
			emailConnected: "Email",
			linkedinType: "LinkedIn Type",
			lastActive: "Last Active",
		},
		yes: "Yes",
		no: "No",
		linkedin: {
			connected: "Connected",
			notConnected: "Not connected",
			disconnected: "Disconnected",
			salesNavDisconnected: "Sales Nav disconnected",
			removed: "Removed",
		},
		connectionType: {
			SALES_NAVIGATOR: "Sales Navigator",
			PREMIUM: "Premium",
			NORMAL: "Normal",
		},
	},
};
